import {combineReducers} from 'redux';
import { DisplayListReducer } from '../reducers/allReducers';

const rootReducer = combineReducers({
    DisplayListReducer
});

export default rootReducer;